import { combineReducers } from "redux"
import { UploadImageReducer } from "./uploadImage"

const FileReducer = combineReducers({
    upload: UploadImageReducer
})

export { FileReducer }
